import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPharmacyIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.4761 10.4677V10.9896C14.7643 10.9896 15 10.7559 15 10.4677H14.4761ZM10.4771 10.4677V9.94586C10.1889 9.94586 9.95321 10.1795 9.95321 10.4677H10.4771ZM14.4761 5.53278H15C15 5.24457 14.7643 5.01093 14.4761 5.01093V5.53278ZM10.4771 5.53278H9.95321C9.95321 5.821 10.1889 6.05464 10.4771 6.05464V5.53278ZM10.4771 1.5492H11.001C11.001 1.26099 10.7653 1.02734 10.4771 1.02734V1.5492ZM5.52297 1.5492V1.02734C5.23475 1.02734 4.99909 1.26099 4.99909 1.5492H5.52297ZM5.52297 5.53278V6.05464C5.81118 6.05464 6.04685 5.821 6.04685 5.53278H5.52297ZM1.52388 5.53278V5.01093C1.23567 5.01093 1 5.24457 1 5.53278H1.52388ZM1.52388 10.4677H1C1 10.7559 1.23567 10.9896 1.52388 10.9896V10.4677ZM5.52297 10.4677H6.04685C6.04685 10.1795 5.81118 9.94586 5.52297 9.94586V10.4677ZM5.52297 14.4513H4.99909C4.99909 14.7395 5.23475 14.9732 5.52297 14.9732V14.4513ZM10.4771 14.4513V14.9732C10.7653 14.9732 11.001 14.7395 11.001 14.4513H10.4771ZM14.4761 9.94586H10.4771V10.9896H14.4761V9.94586ZM13.9522 5.53278V10.4677H15V5.53278H13.9522ZM10.4771 6.05464H14.4761V5.01093H10.4771V6.05464ZM9.95321 1.5492V5.53278H11.001V1.5492H9.95321ZM5.52297 2.07106H10.4771V1.02734H5.52297V2.07106ZM6.04685 5.53278V1.5492H4.99909V5.53278H6.04685ZM1.52388 6.05464H5.52297V5.01093H1.52388V6.05464ZM2.04776 10.4677V5.53278H1V10.4677H2.04776ZM5.52297 9.94586H1.52388V10.9896H5.52297V9.94586ZM6.04685 14.4513V10.4677H4.99909V14.4513H6.04685ZM10.4771 13.9294H5.52297V14.9732H10.4771V13.9294ZM9.95321 10.4677V14.4513H11.001V10.4677H9.95321Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPharmacyIconComponent;
